import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-lg text-black font-bold mb-12\">ご利用申込の流れ</h2><div class=\"max-w-4xl p-8 mb-12 flex flex-col bg-primary-100 rounded-md\"><p class=\"text-sm text-gray-700 mb-5\"> ① みんがくの利用申込にはクレジットカードの登録が必要です。画面下の「支払方法を登録」ボタンを押してください。 </p><p class=\"text-sm text-gray-700 mb-5\"> ② ボタンを押すと支払・請求情報管理ページが開きます。このページの「支払い方法を追加」ボタンから、支払いに利用するクレジットカードを追加してください。 </p><p class=\"text-sm text-gray-700 mb-5\"> ③ クレジットカードの追加が完了したら、「みんがくに戻る」ボタンを押してください。「みんがく」ご利用申込フォームが開きますので、利用規約に同意の上で、申込フォームを送信してください。 </p><p class=\"text-sm text-gray-700\"> ④ 以上でご利用申込完了となります。担当者からご連絡しますので、しばらくお待ちください。 </p></div>", 2)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 支払方法を登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        "font-size": "base",
        onClick: _ctx.redirectCustomerPortal
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}